import { useTranslation } from 'react-i18next';
import { Headings, Paragraph } from '@sentara-health/optimahealth_web';
import WellnessImage_1 from '../../assets/images/Img_Wellness_1.png';
import WellnessImage_2 from '../../assets/images/Img_Wellness_2.png';
import WellnessImage_3 from '../../assets/images/Img_Wellness_3.png';
import WellnessImage_4 from '../../assets/images/Img_Wellness_4.png';
import WellnessImage_5 from '../../assets/images/Img_Wellness_5.png';
import WellnessProgramItem from 'templates/WellnessProgramItem';
import {useContext} from 'react';
import { GlobalContext } from 'context';

const WellnessPrograms = () => {
  const { t } = useTranslation();
  const { ssoEndPoints } = useContext(GlobalContext);

  //static data for wellness programs
  const wellnessPrograms = [
    {
      id: 1,
      img: WellnessImage_1,
      title: t('common.wellnessTools'),
      description: t(
        'wellnessPrograms.wellnessTools.description'
      ),
      link: ssoEndPoints?.wellnessToolsURL,
      linkText: t('wellnessPrograms.wellnessTools.linkText'),
    },
    {
      id: 2,
      img: WellnessImage_2,
      title: t('wellnessPrograms.selfPacedPrograms.title'),
      description: t(
        'wellnessPrograms.selfPacedPrograms.description'
      ),
      link: ssoEndPoints?.selfPacedProgramsURL,
      linkText: t(
        'wellnessPrograms.selfPacedPrograms.linkText'
      ),
    },
    {
      id: 3,
      img: WellnessImage_3,
      title: t('wellnessPrograms.healthyOnDemand.title'),
      description: t(
        'wellnessPrograms.healthyOnDemand.description'
      ),
      link: ssoEndPoints?.healthyOnDemandURL,
      linkText: t('wellnessPrograms.healthyOnDemand.linkText'),
    },
    {
      id: 4,
      img: WellnessImage_4,
      title: t('wellnessPrograms.exclusiveDiscounts.title'),
      description: t(
        'wellnessPrograms.exclusiveDiscounts.description'
      ),
      link: ssoEndPoints?.exclusiveDiscountsURL,
      linkText: t(
        'wellnessPrograms.exclusiveDiscounts.linkText'
      ),
    },
    {
      id: 5,
      img: WellnessImage_5,
      title: t('wellnessPrograms.diabetesPrevention.title'),
      description: t(
        'wellnessPrograms.diabetesPrevention.description'
      ),
      link: ssoEndPoints?.diabetesPreventionURL,
      linkText: t(
        'wellnessPrograms.diabetesPrevention.linkText'
      ),
    },
  ];

  return (
    <div className="enroll_in_benefits black-color">
      <div className="mb-4">
        <Headings
          level={1}
          text={t('dashboard.wellnessTitle')}
          variant="semiBold"
        />
      </div>
      <div>
        <Paragraph
          text={t('dashboard.wellnessContent')}
          variant="regular"
          data-testid="wellnessContent"
        />
      </div>
      <div className="d-flex flex-column gap-5 pt-3 pb-4">
        {wellnessPrograms.map((program, index) => (
          <WellnessProgramItem
            key={program.img}
            program={program}
            index={program.id}
          />
        ))}
      </div>
    </div>
  );
};

export default WellnessPrograms;
